// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9396a24f","879":"567bac8c"}[chunkId] + ".chunk.js";
};